import { useMutation } from '@tanstack/react-query';
import { updateContactPhoneDetails } from '../../services/fn-api/User';

export const useUpdateContactPhoneDetails = () => {
  return useMutation<Record<string, unknown>, Error, Record<string, unknown>>({
    mutationFn: async (data) => {
      return updateContactPhoneDetails(data);
    },
  });
};
